import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';

Vue.use(VueI18n);

export function loadLocaleMessages(): any {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: any = {};
  locales.keys().forEach(key => {
    const locale = key.replace(/\.\/([A-Za-z0-9-_]+).json/i, '$1');
    messages[locale] = locales(key);
  });
  return messages;
}

export default new VueI18n({
  locale: 'pt-br',
  fallbackLocale: 'pt-br',
  messages: loadLocaleMessages(),
});
